import { useContext } from "react";
import { DasboardContext } from "../../context/dashboard-context";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import UserDetailScreen from "../../components/UserDetailScreen/UserDetailScreen";
import "./style.css";

const UserDetail = () => {
  const { sidebarOpen } = useContext(DasboardContext);

  return (
    <>
      <Breadcrumb showPath={"show"} />
      <div
        className={`component-wrapper ${
          sidebarOpen ? "" : "close"
        }`}
      >
        <div className="user-detail-wrapper">
          <UserDetailScreen />
        </div>
      </div>
    </>
  );
};

export default UserDetail;
